const $ = jQuery.noConflict();

'use strict';
const Compare = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domCompareWrap: $('.product-listing__comapre-wrapper'),

	/** @description Initialize */
	init: function() {

		Compare.stickyCompare();
		$('.js-comapre-collapse').on('click', function() {
			Compare.stickyCompare();
		});

		if ($('body.page-template-page-compare').length > 0) {
			Compare.setCookie('isCompare', true);
		}

		if ($('body.post-type-archive-product').length > 0) {
			const isCompare = Compare.readCookie('isCompare');
			Compare.setCookie('isCompare', false);
			if (isCompare) {
				$('body').css('opacity', '0');
				$('header').css('opacity', '0');
				location.href = location.protocol + '//' + location.hostname + '/shop/?load=1&sort=featured';
			}
		}

		if ($('.product-listing__comapre-wrapper').length) {
			$(document).scroll(function() {
				Compare.stickyCompare();
			});
		}

		if ($('.product-listing__comapre-wrapper').length) {
			$('.site-main').on('change keyup click', function() {
				if ($('.product-listing__comapre-wrapper--open').length) {
					$('#tidio-chat-iframe').hide();
				} else {
					$('#tidio-chat-iframe').show();
				}
			});
		}
	},

	stickyCompare: function() {

		const WrapperOffset = $('.product-listing__comapre-wrapper').offset();
		if (!WrapperOffset) {
			return;// prevent JS error on scroll event after closing panel
		}

		if (WrapperOffset.top + $('.product-listing__comapre-wrapper').height() > $('.site-footer').offset().top - 10) {
			$('.product-listing__comapre-wrapper').addClass('product-listing__comapre-wrapper--fixed');
			$('.product-listing__comapre-wrapper').removeClass('product-listing__comapre-wrapper--stick');
		}

		if ($(document).scrollTop() + window.innerHeight < $('.site-footer').offset().top) {
			$('.product-listing__comapre-wrapper').addClass('product-listing__comapre-wrapper--stick');
			$('.product-listing__comapre-wrapper').removeClass('product-listing__comapre-wrapper--fixed');
		}
	},

	/**
	 * @description Set Cookie
	 * @example Global.functions.setCookie('cookie-name');
	 * @param name -> string
	 * @param value -> string|array
	 * @param time -> expiration date
	 * @param path -> path
	 */
	setCookie: function(name, value, time = '01 Jan 1970 00:00:00 UTC', path = '/') {
		const ua = window.navigator.userAgent;

		// IE 10 and lower versions
		// const msie = ua.indexOf('MSIE');

		// IE 11
		const trident = ua.indexOf('Trident/');

		if (!(trident > 0)) {
			time = '';
		}

		document.cookie = name + '=' + JSON.stringify(value) + '; expires=' + time + '; path=' + path + ';';
	},

	/**
	 * @description Get Cookie
	 * @example Global.functions.readCookie('cookie-name');
	 * @param name -> string
	 */
	readCookie: function(name) {
		const nameEQ = name + '=';
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) {
				return JSON.parse(
					c.substring(nameEQ.length, c.length)
				);
			}
		}
		return null;
	},

	/**
	 * @description Delete Cookie
	 * @example Global.functions.deleteCookie('cookie-name');
	 * @param name -> string
	 */
	deleteCookie: function(name) {
		document.cookie = name + '=; Path=/; Expires=Thu, 20 Jun 1989 00:00:01 GMT;';
	},
};

export default Compare;
